export default {
  init() {
    function triggerEvent(elem, type, event) {
      event = document.createEvent("MouseEvents");
      event.initMouseEvent(type, true, true, elem.ownerDocument.defaultView,
        0, 0, 0, 0, 0, false, false, false, false, 0, null);
      elem.dispatchEvent(event);
    }

    var quantity = document.querySelector('form.cart .quantity .qty');
    var _minus = document.createElement('span');
    _minus.classList.add('qty--minus');
    _minus.innerHTML = '-';

    var _plus = document.createElement('span');
    _plus.classList.add('qty--plus');
    _plus.innerHTML = '+';
    document.querySelector('form.cart .quantity').insertBefore(_minus, quantity);
    document.querySelector('form.cart .quantity').appendChild(_plus);
    
    var minus = document.querySelector('form.cart .quantity .qty--minus');
    var plus = document.querySelector('form.cart .quantity .qty--plus');

    quantity.after(plus);

    plus.addEventListener('click', function(){
      var oldValue = quantity.value;
      var newVal = parseFloat(oldValue) + 1;

      quantity.value = newVal;
    })

    minus.addEventListener('click', function () {
      var oldValue = quantity.value;
      var newVal;
      
      if(oldValue > 0) {
        newVal = parseFloat(oldValue) - 1;
      } else {
        newVal = 0;
      }

      quantity.value = newVal;
    })

    var composite = () => {
      var components = document.querySelectorAll('.composite_component');
      // var sidebar = document.querySelector('.sidebar__component--composite');
      // var resume = sidebar.querySelector('.shopping-cart--resume');
      var nameWrapper = document.querySelector('.component__name input');
      var nameMessage = document.querySelector('.component__name .message');
      var addToCart = document.querySelector('.composite_add_to_cart_button');
      var udon = document.querySelector('.variable-item[data-wvstooltip="UDON"]');

      if (document.querySelector('label[for="mitad_y_mitad"]')) {
        document.querySelector('label[for="mitad_y_mitad"]').click();
      }

      document.querySelectorAll('.woocommerce .product .price')[0].style.display = 'none';

      addToCart.addEventListener('click', (e) => {
        if (nameWrapper.value == '') {
          e.preventDefault();
          nameMessage.classList.remove('hidden');
          document.querySelector('.entry-title').scrollIntoView({
            behavior: 'smooth',
          });
        } else {
          if (nameMessage.classList.contains('hidden')) {
            nameMessage.classList.add('hidden');
          }
        }
        
        components.forEach(c => {
          if (c.getAttribute('data-nav_title') == 'ESCOGE LA SALSA' || c.getAttribute('data-nav_title') == 'ESCOGE TU COMPLEMENTO' || c.getAttribute('data-nav_title') == 'EXTRAS') {
            var selections = c.querySelectorAll('.bundled_products .bundled_product.selected');

            if(selections.length < 1) {
              e.preventDefault();
              if(!c.querySelector('.message')) {
                var message = document.createElement('span');

                message.classList.add('message');
                message.classList.add('color--red');
                message.innerText = "Porfavor selecciona como mínimo una opción";
                c.appendChild(message);
              }
              c.scrollIntoView({
                behavior: 'smooth',
              });
            } else {
              if (c.querySelector('.message')) {
                c.querySelector('.message').classList.add('hidden');
              }
            }
          }
        })

      })
      nameWrapper.onchange = () => {
        document.querySelector('.order_item_name').value = nameWrapper.value;
      }

      
      var counter = 1;
      components.forEach(component => {
        var title = component.querySelector('.step_title_wrapper');
        var number = document.createElement('span');
        var imageVariableItems = component.querySelectorAll('.image-variable-item');
        // var selection = [];

        number.classList.add('title__number');
        number.innerHTML = counter + '.';

        if (title.querySelector('.aria_title')) {
          title.insertBefore(number, title.querySelector('.aria_title'));
        }
        counter = counter + 1;

        // var componentTitle = component.querySelector('.component_title_wrapper .title__number').innerText + component.querySelector('.component_title_wrapper .component_title_text').innerText;
        // resume.innerHTML = resume.innerHTML + '<li class="product_wrapper" data-selector="' + component.querySelector('.component_title_wrapper .component_title_text').innerText + '"><span class="">' + componentTitle + '</span></li>';

        imageVariableItems.forEach(imageVariable => {
          // if (imageVariable.getAttribute('data-wvstooltip') == 'UDON') {
          //   imageVariable.classList.add('deselected');
          //   imageVariable.classList.add('no-selectable');
          // }
          imageVariable.addEventListener('click', (e) => {
            if (imageVariable.classList.contains('no-selectable')) {
              e.preventDefault();
              e.stopPropagation();
            } else {
              // if (imageVariable.getAttribute('data-value') == 'Grande') {
              //   if (udon.classList.contains('no-selectable')) {
              //     udon.classList.remove('deselected');
              //     udon.classList.remove('no-selectable');
              //   }
              // }

              if (imageVariable.getAttribute('data-value') == 'Normal') {
                if (udon.classList.contains('selected')) {
                  document.querySelector('.variable-item[data-value="FIDEOS CHINOS"]').click();
                }
              }

              if (imageVariable.getAttribute('data-wvstooltip') == 'UDON') {
                document.querySelector('.variable-item[data-value="Grande"]').click();
              }

              imageVariableItems.forEach(items => {
                items.classList.add('deselected');
              });
  
              imageVariable.classList.remove('deselected');
              
            }
          })
        });

        if (component.classList.contains('options-style-dropdowns')) {
          var selections = component.querySelectorAll('.bundled_products .bundled_product');
          var variations = component.querySelectorAll('.variations .variable-items-wrapper .variable-item');
          var customVariations = component.querySelectorAll('.custom-variations__wrapper');

          if(variations) {
            variations.forEach(variation => {
              var selector = variation.getAttribute('title');
              variation.append(component.querySelector('.allergies__wrapper[data-target="' + selector +'"]'));
              variation.append(component.querySelector('.variation__description[data-target="' + selector +'"]'));

              variation.addEventListener('click', () => {
                var vars = component.querySelectorAll('.allergies__wrapper');

                if(customVariations) {
                  customVariations.forEach(custom => {
                    if(custom.getAttribute('data-target') == selector) {
                      custom.querySelector('.variation__wrapper').classList.add('selected');
                    } else {
                      custom.querySelector('.variation__wrapper').classList.remove('selected');
                    }
                  });
                }
                
                vars.forEach(customVariation => {
                  customVariation.classList.remove('selected');
                });
                // component.querySelector('.variation__wrapper[data-target="' + selector + '"]').classList.toggle('selected');
              })

              if(variation.classList.contains('selected')) {
                // component.querySelector('.variation__wrapper[data-target="' + selector + '"]').classList.toggle('selected');
              }
            });
          }


          if (selections && component.getAttribute('data-nav_title') == 'ESCOGE LA SALSA') {
            var selectionsActived;
            var noSelections = false;
            var selectionsLength = 0;
            selections.forEach(selection => {
              var clickElement = () => {
                selectionsActived = component.querySelectorAll('.bundled_products .bundled_product.selected');
                if (!selection.classList.contains('deselected')) {
                  if (selection.querySelector('.details .bundled_product_title .item_title').innerText == 'SIN SALSA') {
                    selections.forEach(s => {
                      s.classList.toggle('deselected');
                    })
                    selectionsActived.forEach(s => {
                      s.classList.remove('selected');
                      s.querySelector('input').click();
                    })
                    selection.classList.remove('deselected');
                    if(noSelections) {
                      selection.classList.remove('selected');
                    } else {
                      selection.classList.add('selected');
                    }
                    
                    selection.querySelector('input').click();
                    selectionsLength = 0;
                    noSelections = !noSelections;

                  } else {
                    if(!noSelections) {
                      
                      var input = selection.querySelector('input');
                      if (selection.classList.contains('selected') && selectionsLength > 0) {
                        selectionsLength = selectionsLength - 1;
                      } else {
                        selectionsLength = selectionsLength + 1;
                      }
                      selection.classList.toggle('selected');
                      
                      selection.parentElement.setAttribute('data-selected', selectionsLength)
                      input.click();
  
                      if (selectionsLength == 2) {
                        selections.forEach(s => {
                          s.classList.toggle('deselected');
                        })
                        selectionsActived.forEach(s => {
                          s.classList.toggle('deselected');
                        })
                        selection.classList.toggle('deselected');
                      } else {
                        selections.forEach(s => {
                          s.classList.remove('deselected');
                        })
                      }
                    }
                  }
                } else {
                  if (selection.classList.contains('selected')) {
                    var selectedInput = selection.querySelector('input');
                    selection.classList.toggle('selected');
                    selectedInput.click();
                  } else {
                    var description = component.querySelector('.component_description');
                    description.innerHTML = '<p>Puedes elegir hasta <strong>un máximo de 2 salsas</strong> y personalizar la cantidad.</p>';
                  }
                }
              }

              selection.addEventListener('click', function (e) {
                var child = e.target;
                if (child.classList.value.includes('details') || child.classList.value.includes('bundled_product_image')) {
                  clickElement();
                }
              })
              selection.querySelector('.bundled_product_images').addEventListener('click', function () {
                clickElement();
              })
            })
          } else if (selections && component.getAttribute('data-nav_title') == 'Escoge tu salsa') {
            var selectActived;
            var selectQuantity = 0;
            
            selections.forEach(selection => {
              var clickElement = () => {
                selectActived = component.querySelectorAll('.bundled_products .bundled_product.selected');
                if (!selection.classList.contains('deselected')) {
                  
                  var input = selection.querySelector('input');
                  if (selection.classList.contains('selected') && selectQuantity > 0) {
                    selectQuantity = selectQuantity - 1;
                  } else {
                    selectQuantity = selectQuantity + 1;
                  }
                  selection.classList.toggle('selected');

                  selection.parentElement.setAttribute('data-selected', selectQuantity)
                  input.click();

                  if (selectQuantity == 1) {
                    selections.forEach(s => {
                      s.classList.toggle('deselected');
                    })
                    selectActived.forEach(s => {
                      s.classList.toggle('deselected');
                    })
                    selection.classList.toggle('deselected');
                  } else {
                    selections.forEach(s => {
                      s.classList.remove('deselected');
                    })
                  }
                } else {
                  if (selection.classList.contains('selected')) {
                    var selectedInput = selection.querySelector('input');
                    selection.classList.toggle('selected');
                    selectedInput.click();
                  } else {
                    var description = component.querySelector('.component_description');
                    description.innerHTML = '<p>Puedes elegir hasta <strong>un máximo de 1 salsas</strong> y personalizar la cantidad.</p>';
                  }
                }
              }

              selection.addEventListener('click', function (e) {
                var child = e.target;
                if (child.classList.value.includes('details') || child.classList.value.includes('bundled_product_image')) {
                  clickElement();
                }
              })
              selection.querySelector('.bundled_product_images').addEventListener('click', function () {
                clickElement();
              })
            })
          } else if (selections && component.getAttribute('data-max').length > 0) {
            var activated;
            var quantitySelected = 0;
            var numberMax = component.getAttribute('data-max');

            selections.forEach(selection => {
              var clickElement = () => {
                activated = component.querySelectorAll('.bundled_products .bundled_product.selected');
                if (!selection.classList.contains('deselected')) {

                  var input = selection.querySelector('input');
                  if (selection.classList.contains('selected') && quantitySelected > 0) {
                    quantitySelected = quantitySelected - 1;
                  } else {
                    quantitySelected = quantitySelected + 1;
                  }
                  selection.classList.toggle('selected');

                  selection.parentElement.setAttribute('data-selected', quantitySelected)
                  input.click();

                  if (quantitySelected == numberMax) {
                    selections.forEach(s => {
                      s.classList.toggle('deselected');
                    })
                    activated.forEach(s => {
                      s.classList.toggle('deselected');
                    })
                    selection.classList.toggle('deselected');
                  } else {
                    selections.forEach(s => {
                      s.classList.remove('deselected');
                    })
                  }
                } else {
                  if (selection.classList.contains('selected')) {
                    var selectedInput = selection.querySelector('input');
                    selection.classList.toggle('selected');
                    selectedInput.click();
                  } else {
                    var description = component.querySelector('.component_description');
                    description.innerHTML = '<p>Puedes elegir hasta <strong>un máximo de 1 salsas</strong> y personalizar la cantidad.</p>';
                  }
                }
              }

              selection.addEventListener('click', function (e) {
                var child = e.target;
                if (child.classList.value.includes('details') || child.classList.value.includes('bundled_product_image')) {
                  clickElement();
                }
              })
              selection.querySelector('.bundled_product_images').addEventListener('click', function () {
                clickElement();
              })
            })
          } else if (selections && component.getAttribute('data-nav_title') == 'ESCOGE TU COMPLEMENTO') {
            var complementsActived;
            var sLength = 0;

            selections.forEach(selection => {
              var clickElement = () => {
                complementsActived = component.querySelectorAll('.bundled_products .bundled_product.selected');
                
                if (document.querySelector('body').classList.contains('menu-b') || document.querySelector('body').classList.contains('menu-c')) {
                  if (!selection.classList.contains('deselected')) {
                    var input = selection.querySelector('input');
                    if (selection.classList.contains('selected') && sLength > 0) {
                      sLength = sLength - 1;
                    } else {
                      sLength = sLength + 1;
                    }
                    selection.classList.toggle('selected');

                    selection.parentElement.setAttribute('data-selected', sLength);
                    input.click();

                    if (sLength == 2) {
                      selections.forEach(s => {
                        s.classList.toggle('deselected');
                      })
                      complementsActived.forEach(s => {
                        s.classList.toggle('deselected');
                      })
                      selection.classList.toggle('deselected');
                    } else {
                      selections.forEach(s => {
                        s.classList.remove('deselected');
                      })
                    }
                  } else {
                    if (selection.classList.contains('selected')) {
                      var selectedInput = selection.querySelector('input');
                      selection.classList.toggle('selected');
                      selectedInput.click();
                    } else {
                      var description = component.querySelector('.component_description');
                      description.innerHTML = '<p>Puedes elegir hasta <strong>un máximo de 2 complementos</strong>.</p>';
                    }
                  }
                } else {
                  if (!selection.classList.contains('deselected')) {
                    if (selection.classList.contains('selected') && sLength > 0) {
                      sLength = sLength - 1;
                    } else {
                      sLength = sLength + 1;
                    }
                    selection.classList.toggle('selected');

                    selection.parentElement.setAttribute('data-selected', sLength);
                    selection.querySelector('input').click();

                    if (sLength == 1) {
                      selections.forEach(s => {
                        s.classList.toggle('deselected');
                      })
                      complementsActived.forEach(s => {
                        s.classList.toggle('deselected');
                      })
                      selection.classList.toggle('deselected');
                    } else {
                      selections.forEach(s => {
                        s.classList.remove('deselected');
                      })
                    }
                  } else {
                    if (selection.classList.contains('selected')) {
                      selection.classList.toggle('selected');
                      selection.querySelector('input').click();
                    } else {
                      var desc = component.querySelector('.component_description');
                      desc.innerHTML = '<p>Puedes elegir hasta <strong>un máximo de 1 complemento</strong>.</p>';
                    }
                  }
                }
              }
              selection.addEventListener('click', function (e) {
                var child = e.target;
                if (child.classList.value.includes('details') || child.classList.value.includes('bundled_product_image')) {
                  clickElement();
                }
              })
              selection.querySelector('.bundled_product_images').addEventListener('click', function () {
                clickElement();
              })
            })
          } else if(selections && component.getAttribute('data-nav_title') == 'EXTRAS') {
            var actived;
            var noSelected = false;
            var selectedLength = 0;
            selections.forEach(selection => {
              var clickElement = () => {
                actived = component.querySelectorAll('.bundled_products .bundled_product.selected');
                if (!selection.classList.contains('deselected')) {
                  if (selection.querySelector('.details .bundled_product_title .item_title').innerText == 'SIN PROMOCIÓN') {
                    selections.forEach(s => {
                      s.classList.toggle('deselected');
                    })
                    actived.forEach(s => {
                      s.classList.remove('selected');
                      s.querySelector('input').click();
                    })
                    selection.classList.remove('deselected');
                    if (noSelected) {
                      selection.classList.remove('selected');
                    } else {
                      selection.classList.add('selected');
                    }

                    selection.querySelector('input').click();
                    selectedLength = 0;
                    noSelected = !noSelected;

                  } else {
                    if (!noSelected) {

                      var input = selection.querySelector('input');
                      if (selection.classList.contains('selected') && selectedLength > 0) {
                        selectedLength = selectedLength - 1;
                      } else {
                        selectedLength = selectedLength + 1;
                      }
                      selection.classList.toggle('selected');

                      selection.parentElement.setAttribute('data-selected', selectedLength)
                      input.click();

                      if (selectedLength == 1) {
                        selections.forEach(s => {
                          s.classList.toggle('deselected');
                        })
                        actived.forEach(s => {
                          s.classList.toggle('deselected');
                        })
                        selection.classList.toggle('deselected');
                      } else {
                        selections.forEach(s => {
                          s.classList.remove('deselected');
                        })
                      }
                    }
                  }
                } else {
                  if (selection.classList.contains('selected')) {
                    var selectedInput = selection.querySelector('input');
                    selection.classList.toggle('selected');
                    selectedInput.click();
                  } else {
                    var description = component.querySelector('.component_description');
                    description.innerHTML = '<p>Puedes elegir <strong>máximo de 1 promoción</strong>';
                  }
                }
              }

              selection.addEventListener('click', function (e) {
                var child = e.target;
                if (child.classList.value.includes('details') || child.classList.value.includes('bundled_product_image')) {
                  clickElement();
                }
              })
              selection.querySelector('.bundled_product_images').addEventListener('click', function () {
                clickElement();
              })
            })
          } else {
            selections.forEach(selection => {

              var quantity = selection.querySelector('.quantity .qty');
              var quantityWrapper = selection.querySelector('.quantity');
              var _minus = document.createElement('span');
              // var cart = selection.querySelector('.cart');
              _minus.classList.add('qty--minus');
              _minus.innerHTML = '-';

              var _plus = document.createElement('span');
              _plus.classList.add('qty--plus');
              _plus.innerHTML = '+';
              selection.querySelector('.quantity').insertBefore(_minus, quantity);
              selection.querySelector('.quantity').appendChild(_plus);

              var minus = selection.querySelector('.quantity .qty--minus');
              var plus = selection.querySelector('.quantity .qty--plus');

              quantity.after(plus);

              quantityWrapper.classList.add('hidden');

              plus.addEventListener('click', function () {
                var oldValue = quantity.value;
                var newVal = parseFloat(oldValue) + 1;
                // var e = new Event("change");

                quantity.value = newVal;
                triggerEvent(quantity, "change", event);
              })

              minus.addEventListener('click', function () {
                var oldValue = quantity.value;
                var newVal;
                // var o = new Event("change");

                if (oldValue > 0) {
                  newVal = parseFloat(oldValue) - 1;
                } else {
                  newVal = 0;
                }

                quantity.value = newVal;
                triggerEvent(quantity, "change", event);
              })

              selection.addEventListener('click', function (e) {
                var child = e.target;
                if (child.classList.value.includes('details') || child.classList.value.includes('bundled_product_image')) {
                  var input = selection.querySelector('input');
                  selection.classList.toggle('selected');
                  input.click();
                  quantityWrapper.classList.toggle('hidden');
                }
              })

              selection.querySelector('.bundled_product_images').addEventListener('click', function () {
                var input = selection.querySelector('input');
                selection.classList.toggle('selected');
                input.click();
                quantityWrapper.classList.toggle('hidden');
              })

             
            });
          }
        }

        if (component.classList.contains('options-style-thumbnails')) {
          var wrappers = component.querySelectorAll('.component_option_thumbnail');
          var containers = component.querySelectorAll('.component_option_thumbnail_container');

          containers.forEach(container => {
            container.classList.add('actived');
          });

          wrappers.forEach(wrapper => {
            var button = wrapper.querySelector('.button');
            // var id = wrapper.getAttribute('data-val');
            // var title = wrapper.querySelector('.thumbnail_title').innerText;
            // var price = wrapper.querySelector('.woocommerce-Price-amount').innerHtml;

            wrapper.addEventListener('click', function(){
              button.click();

              containers.forEach(container => {
                container.classList.remove('selected');
                container.classList.remove('actived');
              });

              wrapper.parentElement.classList.toggle('selected');
            })
          });
        }
      });
    }

    var variations = () => {
      var variationsWrapper = document.querySelectorAll('.variation__wrapper');
      var selected = [];

      variationsWrapper.forEach(wrapper => {
        var variations = wrapper.querySelectorAll('.variation');
        var input = wrapper.parentElement.querySelector('.variations_selected');
        var componentWrapper = wrapper.closest('.component');

        if(!input) {
          input = document.querySelector('.variations_selected');
        }

        variations.forEach(variation => {
          var val = variation.querySelector('input[type="checkbox"]').getAttribute('value');
          variation.addEventListener('click', () => {
            if (componentWrapper) {
              if (componentWrapper.getAttribute('data-nav_title').includes('SALSA')) {
                variations.forEach(va => {
                  va.classList.remove('selected');
                  var varVal = va.querySelector('input[type="checkbox"]').getAttribute('value')
  
                  if (selected.includes(varVal)) {
                    var pos = selected.findIndex(sel => sel === varVal);
                    selected.splice(pos, 1);
                  }
                })
                selected.push(val);
              } else {
                if(selected.includes(val)) {
                  var p = selected.findIndex(sel => sel === val);
                  selected.splice(p, 1);
  
                } else {
                  selected.push(val);
                }
              }
            } else {
              if (selected.includes(val)) {
                var pr = selected.findIndex(sel => sel === val);
                selected.splice(pr, 1);

              } else {
                selected.push(val);
              }
            }
            variation.classList.toggle('selected');
            input.value = JSON.stringify(selected);
          })
        });
      });
    }

    window.addEventListener("load", () => {
      var product = document.querySelector('.product');
      // var hiddenVariable = document.querySelector('.variable-items-wrapper .variable-item:first-of-type');
      var category = document.querySelector('.product').getAttribute('data-category');
      var nameSetted = localStorage.getItem('category__' + category);

      if (nameSetted && nameSetted !== '') {
        document.querySelector('.order_item_name').value = nameSetted;
      }

      // if(hiddenVariable) {
      //   document.querySelector('.variable-items-wrapper .variable-item:first-of-type').click();
      // }
      
      if (product.classList.contains('product-type-composite')) {
        composite();
        
      }

      if (product.querySelectorAll('variation__wrapper')) {
        variations();
      }
    })
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/single-product.js